<script setup lang="ts">
  import { provide, ref } from 'vue'
  import PinModal from '@/components/modals/PinModal.vue'
  import EmployeeSelectionModal from '@/components/modals/EmployeeSelectionModal.vue'
  import {
    authenticateEmployeeKey,
    selectEmployeeKey,
  } from '@/types/injectionKeys'
  import LoadingLogo from '@/components/LoadingLogo.vue'
  import { storeToRefs } from 'pinia'
  import { useAppStateStore } from './stores/AppStateStore'

  const { isLoading } = storeToRefs(useAppStateStore())

  const pinModal = ref<InstanceType<typeof PinModal>>()
  type AuthenticateEmployeeParams = Parameters<
    NonNullable<typeof pinModal.value>['authenticateEmployee']
  >
  function authenticateEmployee(...args: AuthenticateEmployeeParams) {
    if (!pinModal.value)
      throw new Error('authenticateEmployee was unable to resolve PinModal')
    return pinModal.value.authenticateEmployee(...args)
  }
  provide(authenticateEmployeeKey, authenticateEmployee)

  const employeeSelectionModal =
    ref<InstanceType<typeof EmployeeSelectionModal>>()
  type SelectEmployeeParams = Parameters<
    NonNullable<typeof employeeSelectionModal.value>['selectEmployee']
  >
  function selectEmployee(...args: SelectEmployeeParams) {
    if (!employeeSelectionModal.value)
      throw new Error(
        'selectEmployee was unable to resolve employeeSelectionModal',
      )
    return employeeSelectionModal.value.selectEmployee(...args)
  }
  provide(selectEmployeeKey, selectEmployee)
</script>
<template>
  <slot></slot>
  <loading-logo v-show="isLoading" />
  <pin-modal ref="pinModal" />
  <employee-selection-modal ref="employeeSelectionModal" />
</template>
<!-- global styles can be found in index.css -->
